<template>
  <div>
    <!-- 新增 -->
    <section class="travel-list-box notify">
      <div class="container">
        <div class="box">
          <div class="title-box">
            <h1>通知</h1>
            <hr>
          </div>
          <ul class="tab_box">
            <li>
              <button class="tab_btn" :class="PMTId == -1 ? 'add' : ''" @click="PMTId = -1">全部</button>
            </li>
            <template v-if="PushData">
              <li v-for="PushMessageType in PushData.PushMessageTypes" :key="PushMessageType.PMTId">
                <button class="tab_btn" :class="PMTId == PushMessageType.PMTId ? 'add' : ''"
                  @click="PMTId = PushMessageType.PMTId">{{ PushMessageType.Name }}</button>
              </li>
            </template>
          </ul>
          <div class="list_box show">
            <ul class="list-box show">
              <li v-for="Push in Pushs" class="list-box show">
                <a href="javascript:void(0);" @click="gotoPush(Push)">
                  <div class="img_box">
                    <img src="img/bell.svg" alt="">
                  </div>
                  <div class="text_box">
                    <p v-if="Push.Title">{{ Push.Title }}</p>
                    <p v-else>推播訊息</p>
                    <p style="word-wrap: break-word; word-break: break-all;">{{ Push.Content }}</p>
                    <p class="time">{{ Push.PushTime | timeString("YYYY-MM-DD") }}</p>
                  </div>
                  <!-- <div class="dot"></div> -->
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="page" v-if="pageAll > 1">
        <div class="container">
          <paginate :no-li-surround="false" :page-count="pageAll" :page-range="3" :margin-pages="1"
            :click-handler="loadList" :prev-text="'<'" :next-text="'>'" :prev-link-class="'Prev'"
            :next-link-class="'next'" :container-class="''" :page-link-class="''" :active-class="'page-active'"
            :hide-prev-next="false">
          </paginate>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Paginate from "vuejs-paginate";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.component("paginate", Paginate);
Vue.use(VueI18n);

// this.$t("關閉")
const messages = {
  zh_tw: {
    "關閉": "關閉",
  },
  en: {
    "關閉": "Close",
  },
  jp: {
    "關閉": "閉じる",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "PushList",
  i18n,
  data() {
    return {
      PushData: {},
      Pushs: [],
      pageAll: 0,
      perPage: 10,
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null,
      IsLoaded: false,
      PMTId: -1,
    };
  },
  watch: {
    PMTId(newValue, oldValue) {
      this.loadList(1);
    }
  },
  created: function () {
    Vue.axios
      .get(this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/Push", {
        params: {},
      })
      .then((response) => {
        this.PushData = response.data;
        this.loadList(1);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("travel");
    $(".wrapper").addClass("travel-list");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  updated: function () { },
  methods: {
    loadList: function (page) {
      var that = this;
      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/PushList",
        type: "post",
        data: {
          PMTId: that.PMTId,
          page: page,
          perPage: that.perPage,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.status == 1) {
            that.Pushs = res.Pushs;
            that.perPage = res.perPage;
            that.pageAll = Math.max(Math.ceil(res.total / that.perPage), 1);
            window.pageYOffset = 0;
            window.scrollTo(0, 0);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
          }
        },
      });
    },
    gotoPush: function (Push) {
      if (Push.Type == 1) {
        this.gotoCategory(Push.CId);
      } else if (Push.Type == 2) {
        this.gotoPost(Push.PId);
      } else if (Push.Type == 3) {
        this.gotoUrl(Push.Url);
      }
    },
    gotoCategory: function (CId) {
      this.$router.push({
        name: "Category",
        params: { CId: CId },
      });
    },
    gotoPost: function (PId) {
      this.$router.push({
        name: "Post",
        params: { PId: PId },
      });
    },
    gotoUrl: function (Url) {
      if (this.isMobile && typeof cordova != "undefined") {
        cordova.InAppBrowser.open(
          Url,
          "_system",
          "location=no,hardwareback=no,footer=yes,closebuttoncaption=" +
          this.$t("關閉") +
          ",closebuttoncolor=#ffffff"
        );
      } else {
        window.open(Url, "_blank");
      }
    },
  },
};

Vue.filter("timeString", function (value, myFormat) {
  return moment(value).format(myFormat || "YYYY-MM-DD, HH:mm:ss");
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/PushList.vue